export enum IncentiveRuleKey {
  TSI_SALES = 'TSI_SALES',
  TSI_LIVE_STREAM = 'TSI_LIVE_STREAM',
  TSI_DISCOUNT = 'TSI_DISCOUNT',
  TSI_UNIT_PRICE = 'TSI_UNIT_PRICE',
}
